/**
 * URL da plataforma (app.pix2agro.com.br).
 *
 * Centralizada porque aparece em quatro lugares — nav (desktop e mobile),
 * rodapé e os dois CTAs da página do PixViewer. Antes cada um desses
 * pontos levava para `https://pixviewer.cloud`, o sistema legado: o único
 * caminho do site para um produto apontava para o que está sendo
 * aposentado.
 */
export const APP_URL = 'https://app.pix2agro.com.br';
